// What the shell's sync chip renders. Module-scope zustand (root CLAUDE.md), written only by the
// autosave controller (state/autosave.ts) through `setSync`.

import { create } from 'zustand';
import type { SyncStatus } from '../components/calculator/autosave';

export interface SyncState {
  status: SyncStatus;
  /** Epoch ms of the last successful push; null before the first one. */
  lastSyncedAt: number | null;
  /** Salesforce reconnect URL, present only in the 'reauth' state. */
  oauthUrl: string | null;
  /** Why the last push failed (Salesforce's reasons, one per line); the chip shows it only in the 'error' state. */
  errorMessage: string | null;
}

export const initialState: SyncState = { status: 'local-only', lastSyncedAt: null, oauthUrl: null, errorMessage: null };

export const useSyncStore = create<SyncState>(() => ({ ...initialState }));
